import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-painel-principal',
  templateUrl: './painel-principal.component.html',
  styleUrls: ['./painel-principal.component.scss']
})
export class PainelPrincipalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
